import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { ModalWrapper, TextInput, ButtonBase } from "@repo/ui/index.tsx";
import { inputUtility } from "@repo/utilities/input.utility.ts";
import { FormProvider, useForm } from "react-hook-form";
import { IAddEditModalProps, IGeoScopeFormSchema } from "../geoscope.type";

const AddEditGeoScopeModal = ({
  isOpen,
  editData,
  isLoading,
  handleClose,
  onSubmitHandler,
}: IAddEditModalProps) => {
  const formMethods = useForm<IGeoScopeFormSchema>({
    defaultValues: {
      name: editData?.name,
      code: editData?.code,
    },
  });

  return (
    <ModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleClose}
      title={`${editData?.id ? "Edit" : "Add"} Geo Scopes`}
      description="Manage Geo Scopes here"
      containerClass="w-3/12"
    >
      <FormProvider {...formMethods}>
        <form
          onSubmit={formMethods.handleSubmit(onSubmitHandler)}
          className="flex flex-col gap-2"
        >
          <TextInput
            label="Name"
            placeholder="Enter GeoScope Name..."
            name="name"
            registerOptions={{
              required: "Name is required",
              onChange: (e) => {
                inputUtility.firstLetterCapitalize(e);
                inputUtility.onlyAlphabets(e, 20);
              },
            }}
          />
          <TextInput
            label="Code"
            placeholder="Enter code..."
            name="code"
            registerOptions={{
              required: "Code is required",
              onChange: (e) => {
                inputUtility.allowUnderscoreOnlyValidation(e);
              },
            }}
            disabled={!!editData}
          />
          <section className="flex gap-2 mt-2">
            <ButtonBase
              type="button"
              buttonType="secondary"
              text="Cancel"
              className="w-full"
              onClick={handleClose}
            />
            <ButtonBase
              icon={<ArrowRightIcon className="w-5 h-5" />}
              type="submit"
              buttonType="primary"
              text="Submit"
              className="w-full"
              isLoading={isLoading}
            />
          </section>
        </form>
      </FormProvider>
    </ModalWrapper>
  );
};

export default AddEditGeoScopeModal;
